var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencilFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pencil-fill_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M17.472.807c-.48.087-.842.24-1.188.5-.092.07-2.933 2.878-6.312 6.24-7.33 7.292-6.997 6.958-7.075 7.094-.043.073-.393 1.284-1.086 3.756L.79 22.044l.008.216a.74.74 0 0 0 .101.403c.108.218.233.34.465.454.134.066.187.078.375.086l.218.008 3.647-1.022c2.449-.687 3.683-1.043 3.756-1.085.129-.074.024.03 6.554-6.536 7.117-7.156 6.712-6.745 6.869-6.984.163-.25.267-.486.348-.789.055-.204.062-.276.062-.627 0-.354-.006-.422-.064-.635a3 3 0 0 0-.429-.895c-.171-.227-3.107-3.18-3.319-3.34a3.1 3.1 0 0 0-.864-.424c-.185-.055-.27-.065-.6-.07a5 5 0 0 0-.444.003",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pencil-fill_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgPencilFill;